import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('interactive-table', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('interactive-table');

      return new ViewModel(params, element);
    },
  },
  template: html,
});